import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const CheckItem = props => {
  const classes = classNames({
    'check-item': true,
    'has-error': props.hasError,
    [props.theme]: true
  })
  return (
    <div className={classes}>
      <input
        type='checkbox'
        id={props.id}
        name={props.name}
        value={props.value}
        disabled={props.disabled}
        checked={props.checked}
        onChange={props.onChange}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
      />
      <label className='check-label' htmlFor={props.id}>
        <span className='text'>{props.label}</span>
      </label>
      {props.text && <span className='helper-text'>{props.text}</span>}
      {props.errorText && props.hasError ? (
        <span className='helper-text'>{props.errorText}</span>
      ) : null}
    </div>
  )
}

// Carlos - switched back to errorText because our withReduxFormField
// pass those props. Props should be equal independent of the type of form control

CheckItem.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  theme: PropTypes.oneOf(['light-theme', 'dark-theme']),
  hasError: PropTypes.bool,
  errorText: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func
}

CheckItem.defaultProps = {
  label: 'one',
  id: 'checkbox_sample'
}

export default CheckItem



// WEBPACK FOOTER //
// ./src/ui/forms/check-item.js